// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import HighchartsVue from 'highcharts-vue';

// 🔹 vue-select
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

const app = createApp(App);

app.use(store);
app.use(router);
app.use(HighchartsVue);

// Registramos el componente globalmente
app.component('v-select', vSelect);

app.mount('#app');
